/* prettier-ignore */

import { inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { RestService } from './rest.service';
import { StatisticsService } from './statistics.service';
import { ToolsService } from './tools.service';
import { LocalStorageService } from './localStorage.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  
  private _localStorageService = inject(LocalStorageService);
  
  private userSubject: BehaviorSubject<any | null>;
  public user: Observable<any | null>;
  public isLoggedIn = signal(false);
  
  constructor(
      private router: Router,
      private http: HttpClient,
      private rest: RestService,
      private tools: ToolsService,
      private stats: StatisticsService) 
  {
      const user = this.tools.getWithExpiry('user');
      if (user)
          this.isLoggedIn.set(true)
  
      this.userSubject = new BehaviorSubject(user!);
      this.user = this.userSubject.asObservable();
  }

  public get userValue() {
      return this.userSubject?.value;
  }

  public set userValue(value: any) {
      if (!value){
          this.isLoggedIn.set(false)
          return;
      }
      this.userSubject.next(value);
  }

  login(email: string, password: string, remember: boolean) {
      const payload = { email, password }
      return this.http.post(`${this.rest.apiUrlBase}/api/webapp-login`, payload).pipe(
          map((response: any) => {
              remember 
                  ? localStorage.setItem('user', JSON.stringify(response.data.user)) 
                  : this.tools.setWithExpiry('user', response.data.user, this.rest.ttlTwoHours)
              this.userSubject.next(response.data.user);
              this._localStorageService.setItem('loginResponse', response, 2 * 3600);
              this.isLoggedIn.set(true)
              return response.data.user;
          }
      ));
  }

  logout() {
      this.stats.login = '';
      localStorage.removeItem('user');
      this.userSubject.next(null);
      this.isLoggedIn.set(false)
      this.router.navigateByUrl('/home');
  }

  customLogOut(){
      localStorage.removeItem('user');
      this.userSubject.next(null);
  }


  register(email: string, password: string) {
      const payload = { email, password }
      return this.http.post(`${this.rest.apiUrlBase}/api/send-register`, payload)
  }
}